// extracted by mini-css-extract-plugin
module.exports = {"layout":"Image_layout__2zYbJ","image":"Image_image__193t8","imageCol":"Image_imageCol__2fbE0","textCol":"Image_textCol__1JOSN","fadeIn":"Image_fadeIn__AXIys"};